<template>
    <div class="box">
        <h3 class="title">{{ msg }}</h3> 
        <p>
          欢迎您使用约剑服务！约剑是广州约剑汇体育科技有限公司（以下简称本公司）所拥有和经营的产品。在使用和接受约剑相关产品和服务之前，请您务必仔细阅读本协议，我们珍视您在向我们提供您的个人信息时对我们的信任，我们将按照本隐私政策处理您的个人信息并保障您信息的安全。
        </p>
        <p >版本更新日期：2024年12月06日 </p>
        <p >版本生效日期：2024年12月06日</p>
        
        <p>
          尊敬的约剑用户/主办方:请仔细阅读《约剑隐私政策》(以下简称“本隐私政策”)，充分了解我们对您个人信息的处理规则，如您有任何疑问、意见或建议，您可通过约剑平台与我们联系:
        </p>
        
        <p>一、个人信息定义及范围</p>
        <p>二、我们如何使用和收集您的个人信息</p>
        <p>三、我们如何共享、转让、公开披露您的个人信息</p>
        <p>四、我们如何保护您的个人信息</p>
        <p>六、我们如何存储您的个人信息</p>
        <p>七、我们如何处理儿童的个人信息</p>
        <p>八、本隐私政策如何更新</p>
        <p>九、争议解决</p>
        <p>本隐私政策适用范围</p>
        
        <p>本条款是用户（以下简称“您”）与约剑平台（以下简称“约剑”）之间关于用户使用APP服务所订立的协议。用户是指注册，登录，使用约剑app的个人或组织。</p>
       
        <p>一、个人信息定义及范围</p>
        <p>（一）个人信息：指以电子或者其他方式记录的能够单独或与其他信息结合，识别特定自然人身份或者反映特定自然人活动情况的信息。</p>
        <p>（二）个人敏感信息：包括身份证件号码、手机号码、个人生物识别信息、银行帐号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。</p>
        <p>（三）本隐私政策中涉及的个人信息及个人敏感信息主要包括：</p>
        <p>1.网络身份标识信息： （系统帐号（含第三方微信、QQ，手机号登录等）、IP地址及与前述有关的密码）、昵称、头像；</p>
        <p>2.APP使用数据 （浏览记录、软件使用记录、通过麦克风输入的内容、通过相机拍照的内容）；</p>
        <p>3. 个人常用设备信息（硬件型号、操作系统类型）；</p>
        <p>4. 设备应用安装信息；</p>
        <p>5.使用第三方服务产生的 资金流水记录。</p>

        <p>二、我们如何使用和收集您的个人信息</p>
        <p>1.帮助您成为我们APP的用户</p>
        <p>为使用APP正常服务，您需要首先成为软件的用户，以便我们为您提供会员服务，您需要提供 </p>
        <p>登录APP帐号使用的第三方帐号（如：微信、QQ，手机号登录等）在您主动注销帐号之后，我们将根据法律的要求删除您的个人信息，或使其匿名化处理。</p>
        <p>2.向您提供产品或服务</p>
        <p>（1）产品迭代改进</p>
        <p>
          我们将基于您对软件的使用数据，结合个人常用设备信息进行统计，来诊断系统问题，优化产品体验。我们会使用工具（含第三方工具）统计您在 使用我们产品过程中产生的数据信息，其中包含 应用启动数，页面访问数，重点按钮点击数，设置项的配置属性。随着我们产品的后续版本升级，我们统计的范围会有所改变，您下载/安装/使用我们后续版本产品的行为将被视为您对届时相关改变的同意。
        </p>
        <p>（2）客服与售后</p>
        <p>我们的客服和售后功能会使用您的帐号信息以为您提供咨询服务。</p>
        <p>
          当您与我们的在线客服联系时，我们可能会保存您的通信或通话记录和内容或您留下的联系方式，以便帮助您解决问题，或记录相关问题的处理方案及结果。我们的客服会使用您的帐号信息与您核验您的身份。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息。
        </p>
        <p>3.为您提供安全保护保障</p>
        <p>我们将通过弹出窗口询问您是否可以获取相应权限，只有您选择同意后，我们才会为您开启相应权限并接受您的个人信息。</p>
        <p>我们在您使用服务过程中收集的信息，除法律规定情形外我们都将事先征得您的同意：</p>
        <p>（1）在您首次打开APP时，我们将在取得您的授权后，接受并记录您所使用的设备相关信息，包括：</p>
        <p>
          MEI、IMSI、SIM序列号、唯一设备标识符、OAID、设备设置、用户位置、IP地址、序列号、AndroidId、MSA(oaidlib)、MAC地址、IDFA、系统版本、系统语言、开机时间、运营商、国家代码、手机品牌、手机型号、内存大小、CPU类型、硬盘大小、默认输入法、默认浏览器、IDFV、屏幕尺寸、系统更新时间、Wi-Fi信息、基站信息、ICCID、传感器、运行中的应用程序和进程信息，以保障您的账户及交易安全；为对您的设备进行性能检测和用户标识；
        </p>
        <p>
          （2）在您首次使用打开APP时，我们将在您授权后读取您的手机状态，用以保障APP应用服务的正常使用，更准确定位和解决在使用时遇到的问题，改进及优化APP服务体验，及保障您的帐号安全，如果您拒绝授权此权限，将不能保障应用服务的正常使用，更准确定位和解决在使用时遇到的问题，改进及优化APP服务体验；
        </p>
        <p>
          （3）在您使用文件导入、在线客服（根据您的设备系统不同可能会有场景差异）等功能时，我们将申请您的 存储（和相册）、摄像头权限，以用于导入文件或缓存信息到手机，如果您拒绝授权此权限，将不能正常在APP内拍照、保存图片、文件或缓存信息到手机；
        </p>
        <p>
          （4）在您首次使用在线客服功能时，我们会申请获取您 麦克风权限和存储权限，以用户获取 语音输入，更有效与地客服沟通，如果您拒绝授权此权限，将不能正常使用在线客服语音服务；
        </p>
        <p>
          （5）在您打开APP时，我们将读取您的 应用安装列表、运行中的应用，以防止恶意程序，确保安全运营，并在您对外分享时，为您提供分享服务，如果您拒绝授权此权限，将不能正常防止恶意程序，确保安全运营，以及为您提供分享服务，APP在运行期间，可能会再次读取您的相关信息，包括： MAC地址、操作系统版本、AndroidID、IDFA、ICCID、传感器、Wi-Fi信息、运行中的应用程序和进程信息，以用于后台继续执行未完成的网络请求，我们将把读取频次控制在合理范围内；
        </p>
        <p>
          （6）在您提交问题反馈时，我们将申请您的 电话权限，可能会获取您的手机号码，用于您提交问题反馈后方便我们联系到您。
        </p>
        <p>
          （7）在您点击问题反馈并选择粘贴客服联系方式信息时，我们需要读取您的 剪切板信息，以便复制客服微信或电话快速联系到客服。请您放心，我们不会存储您剪切板的其他信息，且单独的剪切板信息无法识别您的特定身份。
        </p>
        <p>
          （8）在您首次使用APP时，我们会申请您的 应用账户权限，以便您使用手机系统的支付服务，如果您拒绝授权此权限，将不能正常使用手机系统的支付服务在APP进行支付。
        </p>
        <p class="underline">
          个人信息匿名化处理：在收集到您的个人信息后，我们将通过技术手段及时对数据进行匿名化处理。我们会将匿名化后的数据与可用于回复识别个人的信息分开存储，并保证在后续的个人信息处理中不重新识别个人。 在不泄露您个人信息的前提下，我们有权对匿名化处理后的用户数据库进行挖掘、分析和利用（包括商业性使用）。
        </p>
        <p>若我们对于您的个人信息用于除政策列明之外的目的、范围或与使用于数据收集不一致的传输方式时，我们将会通知您并取得您的同意。</p>
        <p>4.征得授权同意的例外</p>
        <p>根据相关法律法规规定及国家标准，以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：</p>
        <p>（1）与国家安全、国防安全直接相关的；</p>
        <p>（2）与公共安全、公共卫生、重大公共利益直接相关；</p>
        <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p>（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
        <p>（5）所收集的个人信息是您自行向社会公众公开的；</p>
        <p>（6）从合法公开披露的信息中收集个人信息的，如：合法的新闻报道、政府信息公开等渠道；</p>
        <p>（7）根据您的要求签订和履行合同所必须的；</p>
        <p>（8）用于维护所提供的产品或服务的安全稳定运行所必需的，发现或处置产品或服务的故障；</p>
        <p>
          （9）为新闻单位或学术研究机构基于新闻报道、公共利益开展统计或学术研究所必要等，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理，且数据接收方无法复原并重新识别个人信息的；
        </p>
        <p>（10） 法律法规规定的其他情形。</p>

        <p>三、我们如何共享，转让，保护您的个人信息</p>
        <p>（一）为提供平台服务的基本功能使用您的个人信息</p>
        <p class="underline">1.您理解和确认，为了提供平台服务基本功能，我们和主办方可能会在实现平台服务和赛事服务基本功能所需的必要范围内使用您的个人信息。</p>
        <p>2．为提供个性化服务使用您个人信息</p>
        <p>
          为了研究体育产业消费趋势，开展广告决策分析，随约剑运营情况推介热门产品或服务，您在此同意，我们可使用您的手机号，结合您的平台订单信息，向您发送手机短信推介您所关注的或可能感兴趣的产品信息，如您不需要此类信息，您可按照我们来信的提示退订，当您退订后，我们将不再向您发送此类信息。
        </p>
        <p>3．其他</p>
        <p>
          请您了解并同意，对于您在使用约剑时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将被视为在您使用约剑期间持续授权我们使用。
        </p>
        <p class="underline">
          在收集您的个人信息后，当我们展示您的个人信息时，我们会采用包括内容替换、泛化处理方式对您的信息进行脱敏，以保护您的信息安全。
        </p>
        <p class="underline">
          4.请您了解并同意,为了保障平台的正常运行及赛事的顺利举办，我们会将平台运营中收集的个人信息用于技术改造、网络维护、故障排除，内部政策与流程制定、统计分析平台运营情况;_在不透露您个人信息的前提下，我们有权对经去标识化、匿名化处理后会员/主办方信息、数据进行分析并予以商业化的利用。
        </p>
        <p>(二)个人信息的对外提供</p>
        <p>未经您同意，我们不会向其他公司、组织和个人提供您的个人信息，但以下情况除外:</p>
        <p>
          1、告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，并取得您的单独同意;
        </p>
        <p>
          2、为了履行我们与您的赛事订单，向主办方等履约必要的供应商、合作方提供订单相关的个人信息;
        </p>
        <p>
          3、履行法定职责或者法定义务所必需;
        </p>
        <p>
          4、为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需;
        </p>
        <p>
          5、为公共利益实施新闻报道、舆论监督等行为，在合理的范围内提供个人信息;
        </p>
        <p>
          6、依法在合理的范围内提供个人自行公开或者其他已经合法公开的个人信息;
        </p>
        <p>
          7、根据适用的强制性法律规定或司法程序要求，应当提供的;
        </p>
        <p>
          8、法律、行政法规规定的其他情形。
        </p>
        <p>
          如我们确需向中华人民共和国境外提供个人信息，且满足法律规定条件的，我们将向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及个人向境外接收方行使本法规定权利的方式和程序等事项，并取得您的单独同意，同时我们也会采取必要措施，保障境外接收方处理个人信息的活动达到中国法律规定的个人信息保护标准。
        </p>
        <p>(三)个人信息的转移</p>
        <p class="underline">
          未经您同意，我们不会将您的个人信息转移给任何公司、组织和个人，但以下情况除外:</p>
        <p class="underline">
          当我们发生合并、分立、解散、被宣告破产等情形，需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方依法将继续履行个人信息处理者的义务。接收方变更原先的处理目的、处理方式的，将重新征求您的同意。
        </p>
        <p>(四)个人信息的公开</p>
        <p>未经您同意，我们不会公开您的个人信息，但以下情况除外:</p>
        <p>1、对于我们在提供产品或服务过程中所处理的您的个人信息，取得您的单独同意后，我们会予以公开;</p>
        <p>
          2、对于您自行公开，或者我们从其他合法渠道获得的已经合法公开的个人信息，在合理的范围内，我们可能在法律允许的范围内予以公开，但您明确拒绝的除外。
        </p>
        <p>(五)个人信息的匿名化处理</p>
        <p>
          请您知悉，根据适用的法律，若我们采用一定技术手段，使得您的个人信息经过处理后无法识别特定自然人且不能复原的，对于该等匿名化处理后的信息，由于其已不再具有个人信息的法律属性，而属于我们享有所有权的数据资源，我们有权自行以共享、转让、公开等商业化方式以及其他方式使用该等匿名化处理后的信息。
        </p>
        <p>(六)个人信息的委托处理</p>
        <p>
          为便于约剑向您提供优质、安全、全方位、紧跟时代的产品和服务，如保护您的个人信息安全，识别会员/主办方账户异常，维护约剑系统的安全、稳定，保护约剑平台安全并使其用户或公众的人身财产安全免遭侵害，研究体育产业消费趋势，开展广告决策分析，随体育场馆运营情况推介热门产品或服务，推介您关注的或可能感兴趣的信息等，我们会委托专业且可靠的机构(简称受托人)处理您的个人信息，我们会与受托人约定委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人信息处理活动进行监督。基于信息处理目的的有限范围，必要时我们会对委托处理的个人信息采取加密、去标识等技术保护措施。您明确知悉并确认，如果受托方恶意违反双方的信息安全相关约定故意或疏忽大意侵犯您的个人信息，我们对因此给您造成的损失不承担责任。
        </p>

        <p>四、我们如何保护您的个人信息</p>
        <p>
          1.我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        </p>
        <p>
          2.我们会采取合理可行的措施，尽力避免收集和处理无关的个人信息。 我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：
        </p>
        <p>1)完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；</p>
        <p>2)保证我们为您提供服务的安全和质量；</p>
        <p>3)您是否同意更长的留存期间；</p>
        <p>4)是否存在保留期限的其他特别约定。</p>
        <p>在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</p>
        <p>
          3.您的个人信息全都被储存在安全的服务器上，并在受控设施中受到保护。我们依据重要性和敏感性对您的数据进行分类，并且保证您的个人信息具有最高的安全等级。我们保证通过访问这些信息来帮助向您提供产品和服务的员工和第三方服务供应商具有严格的合同保密义务，如果未能履行这些义务，其将会受到纪律处分或被终止合作。同样，我们对以云为基础的数据存储设有专门的访问控制措施。总而言之，我们定期审查信息收集、储存和处理实践，包括物理安全措施，以防止任何未经授权的访问和使用。
        </p>
        <p class="underline">
          尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码等个人信息透露给他人。我们将对于个人数据的泄露，及时通知相关的监管机构，并在一些特别的环境下，通知数据主体相关的数据泄露事件，以满足适用的相关法律，包括您所在地的数据保护法规。
        </p>
        <p class="underline">
          我们不对有可能进入第三方网站的隐私政策的合法性负责，您应检查第三方网站的隐私政策并确定是否接受。
        </p>
        <p>
          4.在不幸发生个人信息安全事件后，我们将按照法律法规的要求并最迟不迟于30个自然日内向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范或降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
        </p>

        <p>五、您的权利</p>
        <p>
          按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
        </p>
        <p>1.访问权</p>
        <p>
          您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
        </p>
        <p>
          帐号信息——如果您希望访问您的个人资料信息、退出或注销您的帐号等，您可以通过访问APP内“我的”执行此类操作。
        </p>
        <p>2.删除权</p>
        <p>在以下情形中，您可以向我们提出删除个人信息的要求：</p>
        <p>(1)如果我们处理个人信息的行为违反法律法规；</p>
        <p>(2)如果我们收集、使用您的个人信息，却未征得您的同意；</p>
        <p>(3)如果我们处理个人信息的行为违反了与您的约定；</p>
        <p>(4)如果您不再使用我们的产品或服务，或您注销了帐号；</p>
        <p>(5)如果我们不再为您提供产品或服务；</p>
        <p>
          (6)若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
        </p>
        <p>
          当您被从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
        </p>
        <p>3.撤回同意权</p>
        <p>
          如果您希望收回您授权我们收集和处理您的设备权限（包括：相机、麦克风等），您可以在授权后随时通过“我的-设置-隐私权限设置”收回对该权限的继续授权。撤回同意后，我们后续不会再处理您的个人信息。同时，我们会保障您拒绝接收基于您个人信息的权利。在我们对外共享、转让、公开披露您的个人信息时，我们会向您提供撤回同意的通知。 撤回同意不影响撤回前基于同意的您的个人信息处理。
        </p>
        <p>4.查询权</p>
        <p>可以通过登录APP内“我的”进行查询。</p>

        <p>六、我们如何存储您的个人信息</p>
        <p>(一)存储地点</p>
        <p>我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。</p>
        <p>(二)保存期限</p>
        <p>
          除法律、行政法规另有规定，以及您同意我们保存更长期限外，我们仅会在实现提供场馆服务所必要的期限内保存您的个人信息。在超出保存期限后，我们会依法删除您的个人信息，或进行匿名化处理。
        </p>
        <p>(三）终止服务后的处理</p>
        <p>
          如果我们终止服务或运营，我们会提前通过平台公告、短信、电邮等方式向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
        </p>
        <p>七、我们如何处理儿童的个人信息</p>
        <p class="underline">
          对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
        </p>
        <p class="underline">
          如果我们发现自己在获得可证实的父母不同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
        </p>

        <p>八、本隐私政策如何更新</p>
        <p>
          我们的隐私政策可能变更，我们保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少（即“重大变更”），我们会通过不同渠道向您发送变更通知，包括但不限于APP内弹窗通知及公示、私信通知等方式告知。
        </p>
        <p>
          若您不同意修改后的隐私政策，您有权并应立即停止使用APP的服务。如果您继续使用我们的服务，则视为您接受我们对本政策相关条款所做的修改。
        </p>
        <p>APP的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明APP在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。</p>
        <p>本政策所指的重大变更包括但不限于：</p>
        <p>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
        <p>2.我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
        <p>3.个人信息共享、转让或公开披露的主要对象发生变化；</p>
        <p>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
        <p>5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</p>
        <p>6.个人信息安全影响评估报告表明存在高风险时；</p>
        <p>在APP停止运营时，我们会及时停止继续收集个人信息，将会以APP弹窗通知及公示的形式通知您停止运营的情况，并对您的个人信息进行删除或匿名化处理。</p>
        
        <p>九、如何联系我们</p>
        <p>
          如您对本隐私政策或您个人信息有关事宜有任何问题、异议、意见、建议，对本隐私政策的理解、解释、说明有疑问的，您可通过个人中心，来反馈您的意见建议。
        </p>
        <p>再次感谢您对约剑的信任和使用！</p>

      </div>
  </template>
  
  <script>
  export default {
    name: 'Privacy',
    data(){
      return{
        msg:'约剑隐私协议',
      }
    },
  
    
    methods:{
    }
  
  }
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .box{
    color:#333;
    background-color: #fff;
    padding:30px;
    box-shadow:2px 2px 7px 2px #00000038;
    border-radius:2px;
  }

  p{
    line-height: 2.5;
  }

  .mt-10{
    margin-top:10px;
  }

  .underline{
    text-decoration: underline;
  }

  .color_red{
    color:red;
  }

  .title{
    text-align:center;
    margin-bottom:30px;
  }
</style>
  